/* protoforge.js — site helpers */
function syncHeaderHeight() {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
}

document.addEventListener('DOMContentLoaded', () => {
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav-list]')?.closest('.site-header__nav');

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });

    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target) && !menuToggle.contains(e.target)) {
        nav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  const thumbs = document.querySelectorAll('[data-thumb-src]');
  const mainImage = document.getElementById('ProductImage');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.thumbSrc;
      if (mainImage && src) {
        mainImage.src = src;
        thumbs.forEach((t) => t.classList.remove('product-page__thumb--active'));
        thumb.classList.add('product-page__thumb--active');
      }
    });
  });

  initProductForm();
  initCustomClockConfigurator();
  initQuoteForm();
  initBusinessCardForms();
  initOrderFormLinks();
  initDesignBuilder();
  initAgeGate();
});

function initAgeGate() {
  const root = document.querySelector('[data-age-gate]');
  if (!root) return;
  const key = root.dataset.ageGateKey || 'pfViewNkf';
  const prompt = root.querySelector('[data-age-gate-prompt]');
  const content = root.querySelector('[data-age-gate-content]');
  const confirmBtn = root.querySelector('[data-age-gate-confirm]');

  function showContent() {
    if (prompt) prompt.hidden = true;
    if (content) content.hidden = false;
  }

  if (sessionStorage.getItem(key) === '1') showContent();

  confirmBtn?.addEventListener('click', () => {
    sessionStorage.setItem(key, '1');
    showContent();
    content?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

function initProductForm() {
  const productPage = document.querySelector('[data-product-page]');
  const form = document.querySelector('.product-form');
  if (!form) return;

  const submitButton = form.querySelector('[data-product-submit]') || form.querySelector('[name="add"]');
  const addToCartLabel = submitButton?.dataset.addToCartLabel || submitButton?.textContent?.trim() || 'Add to cart';
  const soldOutLabel = submitButton?.dataset.soldOutLabel || 'Sold out';

  if (form.getAttribute('action') !== '/cart/add') {
    form.setAttribute('action', '/cart/add');
  }

  form.querySelectorAll('input[name="product-id"], input[name="section-id"]').forEach((input) => input.remove());

  let variantInput = form.querySelector('input[name="id"]');
  if (!variantInput) {
    variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.id = 'ProductVariantId';
    variantInput.className = 'product-form__variant-id';
    form.prepend(variantInput);
  }

  const defaultVariantId = productPage?.dataset.defaultVariantId || '';
  if (defaultVariantId) {
    variantInput.value = defaultVariantId;
  }

  const variantsScript = document.getElementById('ProductVariantsJson');
  const optionSelects = form.querySelectorAll('[data-product-option]');
  let variants = [];

  if (variantsScript) {
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (err) {
      console.error('Unable to parse product variants', err);
    }
  }

  function selectedOptions() {
    return Array.from(optionSelects).map((select) => select.value);
  }

  function findVariant() {
    const selected = selectedOptions();
    return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
  }

  function applyVariant(variant) {
    if (!variant) {
      variantInput.value = '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = soldOutLabel;
      }
      return false;
    }

    variantInput.value = String(variant.id);
    if (submitButton) {
      submitButton.disabled = !variant.available;
      submitButton.textContent = variant.available ? addToCartLabel : soldOutLabel;
    }
    return variant.available;
  }

  function updateVariantState() {
    if (!variants.length || !optionSelects.length) return applyVariant(variants[0] || null);
    return applyVariant(findVariant());
  }

  if (variants.length && optionSelects.length) {
    optionSelects.forEach((select) => select.addEventListener('change', updateVariantState));
    updateVariantState();
  }

  async function ensureVariantId() {
    if (variantInput.value) return true;

    const handle = productPage?.dataset.productHandle
      || window.location.pathname.split('/').filter(Boolean).pop();
    if (!handle) return false;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`);
      if (!response.ok) return false;
      const product = await response.json();
      variants = product.variants || [];
      const variant = findVariant() || variants.find((entry) => entry.available) || variants[0];
      return applyVariant(variant);
    } catch (err) {
      console.error('Unable to load product variant', err);
      return false;
    }
  }

  form.addEventListener('submit', (event) => {
    if (variantInput.value) return;
    event.preventDefault();
    ensureVariantId().then((ready) => {
      if (ready) form.submit();
    });
  });

  if (!variantInput.value) {
    ensureVariantId();
  }
}

function initCustomClockConfigurator() {
  const root = document.querySelector('[data-custom-clock]');
  if (!root) return;

  const form = root.querySelector('[data-clock-form]');
  const variantInput = root.querySelector('[data-clock-variant-id]');
  const handsInputs = root.querySelectorAll('[data-clock-hands]');
  const handsProp = root.querySelector('[data-clock-hands-prop]');
  const customHandsPanel = root.querySelector('[data-custom-hands-panel]');
  const customHandsDetails = root.querySelector('[data-custom-hands-details]');
  const enclosureCheck = root.querySelector('[data-custom-enclosure]');
  const enclosureWarning = root.querySelector('[data-enclosure-warning]');
  const enclosurePanel = root.querySelector('[data-enclosure-panel]');
  const enclosureDetails = root.querySelector('[data-enclosure-details]');
  const addToCartBtn = root.querySelector('[data-clock-add-to-cart]');
  const quoteLink = root.querySelector('[data-clock-quote-link]');
  const quoteHint = root.querySelector('[data-clock-quote-hint]');
  const totalEl = root.querySelector('[data-clock-total]');
  const priceDisplay = root.querySelector('[data-clock-price-display]');
  const qtyInput = root.querySelector('[data-clock-qty]');
  const addToCartLabel = addToCartBtn?.dataset.addToCartLabel || 'Add to cart';

  const basePrice = parseFloat(root.dataset.basePrice || root.dataset.listedPrice || '50');
  const customHandsPrice = parseFloat(root.dataset.customHandsPrice || '50');

  function selectedHands() {
    return root.querySelector('[data-clock-hands]:checked');
  }

  function isCustomHands() {
    return selectedHands()?.dataset.isCustomHands === 'true';
  }

  function isCustomEnclosure() {
    return Boolean(enclosureCheck?.checked);
  }

  function unitPrice() {
    const hands = selectedHands();
    if (hands?.dataset.price) {
      const p = parseFloat(String(hands.dataset.price).replace(/[^0-9.]/g, ''));
      if (!Number.isNaN(p)) return p;
    }
    return isCustomHands() ? customHandsPrice : basePrice;
  }

  function updateUI() {
    const hands = selectedHands();
    if (hands && variantInput) {
      variantInput.value = hands.dataset.variantId || variantInput.value;
    }
    if (handsProp && hands) {
      handsProp.value = hands.value;
    }

    if (customHandsPanel) {
      customHandsPanel.hidden = !isCustomHands();
      if (!isCustomHands() && customHandsDetails) customHandsDetails.value = '';
    }

    const enclosure = isCustomEnclosure();
    if (enclosureWarning) enclosureWarning.hidden = !enclosure;
    if (enclosurePanel) {
      enclosurePanel.hidden = !enclosure;
      if (!enclosure && enclosureDetails) enclosureDetails.value = '';
    }

    const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
    const total = unitPrice() * qty;
    if (totalEl) {
      totalEl.textContent = enclosure
        ? 'Custom enclosure — quote required (pricing not available at checkout)'
        : `Total: $${total.toFixed(2)}`;
    }
    if (priceDisplay && !enclosure) {
      priceDisplay.textContent = isCustomHands()
        ? `$${customHandsPrice.toFixed(0)} as shown`
        : `$${basePrice.toFixed(0)} standard hands`;
    }

    if (addToCartBtn) {
      addToCartBtn.hidden = enclosure;
      addToCartBtn.disabled = enclosure;
      addToCartBtn.textContent = addToCartLabel;
    }
    if (quoteLink) quoteLink.hidden = !enclosure;
    if (quoteHint) quoteHint.hidden = !enclosure;
  }

  function storeQuotePrefill() {
    const hands = selectedHands();
    const lines = [
      `Custom Made Clock quote: ${root.dataset.productHandle || 'clock'}`,
      `Product: Frog Clock`,
      `Clock hands: ${hands?.value || ''}`,
    ];
    if (isCustomHands() && customHandsDetails?.value?.trim()) {
      lines.push(`Custom hands details: ${customHandsDetails.value.trim()}`);
    }
    if (isCustomEnclosure()) {
      lines.push('Custom enclosure: Yes — quote required for pricing');
      if (enclosureDetails?.value?.trim()) {
        lines.push(`Enclosure design request: ${enclosureDetails.value.trim()}`);
      }
      lines.push('Note: Clock face is 8 inches wide. Mock-ups for approval as we design together.');
    }
    lines.push('I may email a photo mock-up for approval before assembling custom hands.');
    form.querySelectorAll('input[type="hidden"]').forEach((input) => {
      if (input.name && input.name.indexOf('reference URLs') !== -1 && input.value.trim()) {
        lines.push(`${input.name.replace('properties[', '').replace(']', '')}: ${input.value.trim()}`);
      }
    });

    sessionStorage.setItem('pfProductTitle', 'Frog Clock — Custom Made Clock');
    sessionStorage.setItem('pfQuoteItem', 'Custom Made Clock');
    sessionStorage.setItem('pfSublimationQuote', '');
    sessionStorage.setItem('pfQuotePrefillLabel', 'Custom Made Clock request:');
    sessionStorage.setItem('pfBlankOptions', lines.join('\n'));
    sessionStorage.setItem('pfBlankType', hands?.value || '');
    sessionStorage.setItem('pfDesignTitle', 'Frog Clock');
  }

  handsInputs.forEach((input) => input.addEventListener('change', updateUI));
  enclosureCheck?.addEventListener('change', updateUI);
  qtyInput?.addEventListener('input', updateUI);
  qtyInput?.addEventListener('change', updateUI);

  form?.addEventListener('submit', async (e) => {
    if (form.dataset.pfReady === '1') {
      form.dataset.pfReady = '';
    } else if (form.querySelector('[data-pf-upload]') && window.PfArtworkUpload) {
      e.preventDefault();
      const uploaded = await PfArtworkUpload.prepare(form);
      if (!uploaded.ok) return;
      form.dataset.pfReady = '1';
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
      return;
    }
    if (isCustomEnclosure()) {
      e.preventDefault();
      storeQuotePrefill();
      if (quoteLink?.href) window.location.href = quoteLink.href;
      return;
    }
    if (isCustomHands() && customHandsDetails && !customHandsDetails.value.trim()) {
      e.preventDefault();
      customHandsDetails.focus();
      alert('Please describe your custom clock hands (shape, theme, and style).');
      return;
    }
    const hands = selectedHands();
    if (hands && variantInput) variantInput.value = hands.dataset.variantId || variantInput.value;
    if (handsProp && hands) handsProp.value = hands.value;
  });

  quoteLink?.addEventListener('click', () => {
    storeQuotePrefill();
  });

  updateUI();
}

function initQuoteForm() {
  const form = document.getElementById('QuoteRequestForm');
  if (!form) return;

  const bodyField = document.getElementById('QuoteBody');
  const estimateBox = document.querySelector('[data-quote-estimate]');
  const estimateValue = document.querySelector('[data-estimate-value]');
  const serviceChecks = form.querySelectorAll('[data-quote-service]');
  const designFeeCheck = form.querySelector('[data-quote-design-fee]');
  const quantityField = document.getElementById('QuoteQuantity');
  const effectiveDate = document.querySelector('[data-quote-section] .quote-page__effective-date');
  let designFeeAmount = designFeeCheck
    ? parseFloat(designFeeCheck.dataset.designFee || '5')
    : 0;
  const promoDiscountPercent = parseFloat(sessionStorage.getItem('pfPromoDiscount') || '0');
  const promoLabel = sessionStorage.getItem('pfPromoLabel') || '';
  const storedDesignFee = parseFloat(sessionStorage.getItem('pfDesignFee') || '0');
  if (storedDesignFee > 0) {
    designFeeAmount = storedDesignFee;
    if (designFeeCheck) {
      designFeeCheck.dataset.designFee = String(storedDesignFee);
      const feeLabel = designFeeCheck.closest('label')?.querySelector('.quote-checkbox__price');
      if (feeLabel) {
        feeLabel.textContent = `+$${storedDesignFee.toFixed(2)} for us to create your custom design`;
      }
    }
  }
  const metalCardService = form.querySelector('[data-metal-card-service]');
  const metalCardOptions = form.querySelector('[data-metal-card-options]');
  const metalCardPrintRadios = form.querySelectorAll('[data-metal-card-print]');
  const METAL_CARD_MIN_QTY = 5;

  function parsePrice(str) {
    if (!str || /custom/i.test(str)) return null;
    const match = str.replace(/,/g, '').match(/\$?\s*(\d+(?:\.\d{2})?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function isPerCardService(cb) {
    return cb.dataset.perCard === 'true' || /per card/i.test(cb.dataset.unit || '');
  }

  function getMetalCardRate() {
    const selected = Array.from(metalCardPrintRadios).find((r) => r.checked);
    return selected ? parseFloat(selected.dataset.rate || '0.25') : 0.25;
  }

  function getMetalCardPrintLabel() {
    const selected = Array.from(metalCardPrintRadios).find((r) => r.checked);
    if (!selected) return 'One sided print with white back';
    return selected.value === 'two-sided'
      ? 'Two sided print ($0.50/card)'
      : 'One sided print with white back ($0.25/card)';
  }

  function isMetalCardSelected() {
    return Boolean(metalCardService?.checked);
  }

  function getSelectedServices() {
    return Array.from(serviceChecks)
      .filter((cb) => cb.checked)
      .map((cb) => {
        const isMetalCard = cb.hasAttribute('data-metal-card-service');
        const amount = isMetalCard ? getMetalCardRate() : parsePrice(cb.dataset.price);
        const price = isMetalCard ? `$${getMetalCardRate().toFixed(2)}` : cb.dataset.price;
        return {
          name: cb.value,
          price,
          unit: cb.dataset.unit,
          category: cb.dataset.category,
          amount,
          perCard: isPerCardService(cb) || isMetalCard,
          isBusinessCard: cb.dataset.category === 'Business Cards',
          isMetalCard,
        };
      });
  }

  function parseQuantity(str) {
    if (!str) return 1;
    const match = str.match(/(\d+)/);
    return match ? Math.max(1, parseInt(match[1], 10)) : 1;
  }

  function serviceQuantity(service, baseQty) {
    if (service.perCard || service.isMetalCard) {
      return Math.max(baseQty, METAL_CARD_MIN_QTY);
    }
    return baseQty;
  }

  function toggleMetalCardOptions() {
    if (!metalCardOptions) return;
    metalCardOptions.hidden = !isMetalCardSelected();
    if (isMetalCardSelected() && quantityField) {
      const qty = parseQuantity(quantityField.value);
      if (qty < METAL_CARD_MIN_QTY) quantityField.value = String(METAL_CARD_MIN_QTY);
    }
  }

  function updateEstimate() {
    if (!estimateBox || !estimateValue) return;

    const services = getSelectedServices();
    const baseQty = parseQuantity(quantityField?.value);
    const priced = services.filter((s) => s.amount !== null);

    if (priced.length === 0) {
      estimateBox.hidden = true;
      return;
    }

    let total = priced.reduce((sum, s) => sum + s.amount * serviceQuantity(s, baseQty), 0);

    if (designFeeCheck?.checked && designFeeAmount > 0) {
      const businessCards = services.filter((s) => s.isBusinessCard);
      const otherServices = services.filter((s) => !s.isBusinessCard);
      if (businessCards.length) total += 10;
      if (otherServices.length) total += designFeeAmount * otherServices.length * baseQty;
    }

    if (promoDiscountPercent > 0) {
      total *= (100 - promoDiscountPercent) / 100;
    }

    let estimateText = `From $${total.toFixed(2)} — taxes & shipping not included`;
    if (promoDiscountPercent > 0) {
      estimateText += ` (${promoDiscountPercent}% promo discount applied)`;
    }
    estimateValue.textContent = estimateText;
    estimateBox.hidden = false;
  }

  function buildQuoteBody() {
    const fields = {
      phone: form.querySelector('[data-quote-field="phone"]'),
      company: form.querySelector('[data-quote-field="company"]'),
      project: form.querySelector('[data-quote-field="project"]'),
      quantity: form.querySelector('[data-quote-field="quantity"]'),
      deadline: form.querySelector('[data-quote-field="deadline"]'),
      description: form.querySelector('[data-quote-field="description"]'),
      budget: form.querySelector('[data-quote-field="budget"]'),
      notes: form.querySelector('[data-quote-field="notes"]'),
    };

    const services = getSelectedServices();
    const lines = ['=== QUOTE REQUEST — ProtoForge Creations ===', ''];

    if (effectiveDate) {
      lines.push(effectiveDate.textContent.trim());
      lines.push('');
    }

    lines.push(`Project: ${fields.project?.value || '—'}`);
    if (fields.company?.value) lines.push(`Company: ${fields.company.value}`);
    if (fields.quantity?.value) lines.push(`Quantity: ${fields.quantity.value}`);
    if (fields.deadline?.value) lines.push(`Deadline: ${fields.deadline.value}`);
    if (fields.budget?.value) lines.push(`Budget range: ${fields.budget.value}`);

    lines.push('');
    lines.push('--- Selected Services ---');
    if (services.length) {
      services.forEach((s) => {
        lines.push(`• ${s.name} — ${s.price}${s.unit ? ' (' + s.unit + ')' : ''}`);
        if (s.isMetalCard) {
          lines.push(`  - Print type: ${getMetalCardPrintLabel()}`);
          lines.push(`  - Minimum quantity: ${METAL_CARD_MIN_QTY} cards`);
        }
        lines.push('  - Customer supplied image file');
      });
    } else {
      lines.push('(none selected)');
    }

    lines.push('');
    lines.push(`Custom design by ProtoForge (+$${designFeeAmount} per item): ${designFeeCheck?.checked ? 'YES' : 'No — customer will supply image'}`);

    if (promoLabel || promoDiscountPercent > 0) {
      lines.push('');
      lines.push('--- Promotional Pricing ---');
      if (promoLabel) lines.push(`Promotion: ${promoLabel}`);
      if (promoDiscountPercent > 0) lines.push(`Discount: ${promoDiscountPercent}% off selected items`);
      if (storedDesignFee > 0) lines.push(`Custom design fee for this promotion: $${storedDesignFee.toFixed(2)} per item`);
    }

    if (estimateValue && !estimateBox?.hidden) {
      lines.push('');
      lines.push(`Customer estimated starting total: ${estimateValue.textContent}`);
    }

    const designTitle = sessionStorage.getItem('pfDesignTitle');
    const designFile = sessionStorage.getItem('pfDesignFile');
    const designImageUrl = sessionStorage.getItem('pfDesignImageUrl');
    const sourceFolder = sessionStorage.getItem('pfSourceFolder');
    const blankType = sessionStorage.getItem('pfBlankType');

    const customerUpload = sessionStorage.getItem('pfCustomerUpload') === 'true';

    if (designTitle || designFile) {
      lines.push('');
      const prefillLabel = sessionStorage.getItem('pfQuotePrefillLabel') || 'Create Your Own Sublimation request:';
      lines.push(`--- Selected Design (${prefillLabel.replace(/:$/, '')}) ---`);
      if (designTitle) lines.push(`Design title: ${designTitle}`);
      if (customerUpload) {
        if (designFile) lines.push(`Customer-provided image file: ${designFile}`);
        lines.push('Note: Customer will attach the full-resolution image file with this quote request.');
      } else {
        if (designFile) lines.push(`Design file (reviewed folder): ${designFile}`);
        if (sourceFolder) lines.push(`Source folder: ${sourceFolder}`);
        if (designImageUrl) {
          lines.push(`Design image (open or save): ${designImageUrl}`);
        }
      }
      if (blankType) lines.push(`Blank type: ${blankType}`);
      const blankAddons = sessionStorage.getItem('pfBlankAddons');
      if (blankAddons) lines.push(`Add-ons: ${blankAddons}`);
      const blankOptions = sessionStorage.getItem('pfBlankOptions');
      if (blankOptions) lines.push(`Blank options: ${blankOptions}`);
    }

    lines.push('');
    lines.push('--- Project Description ---');
    lines.push(fields.description?.value || '—');

    if (fields.notes?.value) {
      lines.push('');
      lines.push('--- Additional Notes ---');
      lines.push(fields.notes.value);
    }

    if (form.dataset.pfUploadLines) {
      lines.push('');
      lines.push(designFeeCheck?.checked ? '--- Reference images ---' : '--- Artwork files ---');
      lines.push(form.dataset.pfUploadLines);
    }

    return lines.join('\n');
  }

  serviceChecks.forEach((cb) => {
    cb.addEventListener('change', () => {
      toggleMetalCardOptions();
      updateEstimate();
    });
  });
  metalCardPrintRadios.forEach((radio) => radio.addEventListener('change', updateEstimate));
  function syncQuoteUploadMode() {
    const upload = form.querySelector('[data-pf-upload]');
    if (upload && window.PfArtworkUpload) {
      const alreadyHasFile = Boolean(sessionStorage.getItem('pfDesignImageUrl'));
      PfArtworkUpload.setMode(upload, designFeeCheck?.checked || alreadyHasFile ? 'design' : 'supply');
    }
  }
  designFeeCheck?.addEventListener('change', () => {
    updateEstimate();
    syncQuoteUploadMode();
  });
  syncQuoteUploadMode();
  quantityField?.addEventListener('input', () => {
    toggleMetalCardOptions();
    updateEstimate();
  });
  toggleMetalCardOptions();

  function applyDesignFieldsToForm() {
    const map = [
      ['pfDesignTitle', 'QuoteDesignTitle'],
      ['pfDesignFile', 'QuoteDesignFile'],
      ['pfBlankType', 'QuoteBlankTypeField'],
      ['pfBlankAddons', 'QuoteBlankAddonsField'],
      ['pfBlankOptions', 'QuoteBlankOptionsField'],
      ['pfDesignImageUrl', 'QuoteDesignImageUrl'],
      ['pfSourceFolder', 'QuoteSourceFolder'],
    ];
    map.forEach(([storageKey, fieldId]) => {
      const el = document.getElementById(fieldId);
      const value = sessionStorage.getItem(storageKey);
      if (el && value) el.value = value;
    });
  }

  function quoteVisibleFieldsHaveValues() {
    return ['#QuoteCompany', '#QuoteProject', '#QuoteQuantity', '#QuoteDeadline', '#QuoteDescription', '#QuoteBudget', '#QuoteNotes']
      .some((selector) => form.querySelector(selector)?.value?.trim());
  }

  function refillQuoteBody() {
    applyDesignFieldsToForm();
    if (bodyField) bodyField.value = buildQuoteBody();
  }

  function refillQuoteBodyAfterCaptcha() {
    const params = new URLSearchParams(window.location.search);
    if (!params.get('form_key')) return;
    if (!quoteVisibleFieldsHaveValues()) return;
    refillQuoteBody();
  }

  applyDesignFieldsToForm();
  refillQuoteBodyAfterCaptcha();
  window.addEventListener('pageshow', refillQuoteBodyAfterCaptcha);

  form.addEventListener('submit', async (e) => {
    if (form.dataset.pfReady === '1') {
      if (bodyField && !bodyField.value.trim() && quoteVisibleFieldsHaveValues()) {
        refillQuoteBody();
      }
      return;
    }
    if (!bodyField) return;
    e.preventDefault();
    if (!form.querySelector('#QuoteProject')?.value.trim()) {
      alert('Please enter a project title.');
      return;
    }
    if (!form.querySelector('#QuoteDescription')?.value.trim()) {
      alert('Please describe your project.');
      return;
    }
    if (isMetalCardSelected() && parseQuantity(quantityField?.value) < METAL_CARD_MIN_QTY) {
      alert(`Sublimation Metal Cards require a minimum of ${METAL_CARD_MIN_QTY} cards per order.`);
      return;
    }
    refillQuoteBody();
    if (!window.PfArtworkUpload) {
      alert('File upload did not load. Refresh the page and try again.');
      return;
    }
    const uploaded = await PfArtworkUpload.prepare(form);
    if (!uploaded.ok) return;
    const urlField = document.getElementById('QuoteDesignImageUrl');
    const fileField = document.getElementById('QuoteDesignFile');
    if (uploaded.urls.length) {
      const lines = uploaded.urls.map((url, index) => `${uploaded.names[index]}: ${url}`);
      form.dataset.pfUploadLines = lines.join('\n');
      const prior = urlField?.value?.trim();
      if (urlField) urlField.value = [prior, ...uploaded.urls].filter(Boolean).join('\n');
      if (fileField && !fileField.value) fileField.value = uploaded.names.join(', ');
    }
    refillQuoteBody();
    form.dataset.pfReady = '1';
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });
}

function initBusinessCardForms() {
  [
    document.getElementById('BusinessCardOrderForm'),
    document.getElementById('PremiumBusinessCardOrderForm'),
  ].forEach((form) => {
    if (form) setupBusinessCardForm(form);
  });
}

function setupBusinessCardForm(form) {
  const isPremium = form.id === 'PremiumBusinessCardOrderForm';
  const bodyField = form.querySelector('[data-bc-body]');
  const estimateValue = form.querySelector('[data-bc-estimate-value]');
  const qtyInput = form.querySelector('[data-bc-qty]');
  const typeRadios = form.querySelectorAll('[data-bc-type]');
  const designCheck = form.querySelector('[data-bc-design]');
  const designFeeDisplay = form.querySelector('[data-bc-design-fee-display]');
  const designLabel = form.querySelector('[data-bc-design-label]');
  const customerArtCheck = form.querySelector('[data-bc-customer-art]');
  const designFeeOne = designCheck ? parseFloat(designCheck.dataset.bcDesignFeeOne || '5') : 5;
  const designFeeTwo = designCheck ? parseFloat(designCheck.dataset.bcDesignFeeTwo || '10') : 10;

  const minQty = parseInt(qtyInput?.dataset.bcMinQty || '5', 10) || 5;
  const typeLabels = {
    sublimation_one: 'One sided print with white back ($0.25/card, min 5)',
    sublimation_two: 'Two sided print ($0.50/card, min 5)',
    premium_two_sided: 'Premium 0.7mm aluminum — two sided print ($2.00/card, min 5)',
  };

  function getSelectedType() {
    if (isPremium) {
      const fixed = form.querySelector('[data-bc-type][data-bc-rate]');
      const rate = fixed ? parseFloat(fixed.dataset.bcRate || '2') : 2;
      return {
        value: 'premium_two_sided',
        rate,
        label: typeLabels.premium_two_sided,
        isOneSided: false,
      };
    }
    const selected = Array.from(typeRadios).find((r) => r.checked && r.type === 'radio');
    if (!selected) return null;
    return {
      value: selected.value,
      rate: parseFloat(selected.dataset.bcRate || '0.25'),
      label: typeLabels[selected.value] || selected.value,
      isOneSided: selected.value === 'sublimation_one',
    };
  }

  function getDesignFee() {
    const type = getSelectedType();
    if (isPremium) return designFeeTwo;
    return type?.isOneSided ? designFeeOne : designFeeTwo;
  }

  function updateDesignFeeDisplay() {
    const type = getSelectedType();
    const fee = getDesignFee();
    if (designFeeDisplay) {
      designFeeDisplay.textContent = `+$${fee.toFixed(2)} one-time fee`;
    }
    if (designLabel && !isPremium) {
      designLabel.textContent = type?.isOneSided
        ? 'Custom design by ProtoForge (one side)'
        : 'Custom design by ProtoForge (both sides)';
    }
  }

  function getQuantity() {
    const q = parseInt(qtyInput?.value, 10);
    if (Number.isNaN(q) || q < minQty) return minQty;
    return q;
  }

  function fieldValue(name) {
    const el = form.querySelector(`[data-bc-field="${name}"]`);
    return el?.value?.trim() || '';
  }

  function updateEstimate() {
    if (!estimateValue) return;
    const type = getSelectedType();
    const qty = getQuantity();
    if (!type) return;

    let total = type.rate * qty;
    if (designCheck?.checked) total += getDesignFee();
    estimateValue.textContent = `$${total.toFixed(2)} — taxes & shipping not included`;
  }

  function buildBody() {
    const type = getSelectedType();
    const qty = getQuantity();
    const orderTitle = isPremium
      ? '=== PREMIUM BUSINESS CARD ORDER — ProtoForge Creations ==='
      : '=== BUSINESS CARD ORDER — ProtoForge Creations ===';
    const lines = [orderTitle, ''];

    lines.push('--- Customer Information ---');
    if (fieldValue('order_date')) lines.push(`Order date: ${fieldValue('order_date')}`);
    if (fieldValue('po_number')) lines.push(`PO / Quote #: ${fieldValue('po_number')}`);
    lines.push(`Contact name: ${fieldValue('contact_name') || '—'}`);
    if (fieldValue('company')) lines.push(`Company: ${fieldValue('company')}`);
    if (fieldValue('shipping_address')) lines.push(`Shipping address: ${fieldValue('shipping_address')}`);
    const cityLine = [fieldValue('city'), fieldValue('state'), fieldValue('zip')].filter(Boolean).join(', ');
    if (cityLine) lines.push(`City/State/ZIP: ${cityLine}`);
    if (fieldValue('phone')) lines.push(`Phone: ${fieldValue('phone')}`);
    lines.push(`Email: ${fieldValue('email') || '—'}`);

    lines.push('');
    lines.push('--- Business Card Text (Front) ---');
    if (fieldValue('card_full_name')) lines.push(`Name: ${fieldValue('card_full_name')}`);
    if (fieldValue('card_title')) lines.push(`Title: ${fieldValue('card_title')}`);
    if (fieldValue('card_company')) lines.push(`Company: ${fieldValue('card_company')}`);
    if (fieldValue('card_address')) lines.push(`Address: ${fieldValue('card_address')}`);
    if (fieldValue('card_phone')) lines.push(`Phone on card: ${fieldValue('card_phone')}`);
    if (fieldValue('card_email')) lines.push(`Email on card: ${fieldValue('card_email')}`);
    if (fieldValue('card_website')) lines.push(`Website: ${fieldValue('card_website')}`);

    lines.push('');
    lines.push('--- Print Options ---');
    lines.push(`Card type: ${type?.label || '—'}`);
    lines.push(`Quantity: ${qty}`);
    lines.push(
      `Custom design by ProtoForge (+$${getDesignFee().toFixed(2)}): ${designCheck?.checked ? 'YES' : 'No'}`
    );
    lines.push(
      `Customer provides print-ready artwork: ${customerArtCheck?.checked ? 'YES' : 'No'}`
    );

    if (type && estimateValue) {
      lines.push('');
      lines.push(`Estimated total: ${estimateValue.textContent}`);
    }

    if (fieldValue('notes')) {
      lines.push('');
      lines.push('--- Notes & Special Instructions ---');
      lines.push(fieldValue('notes'));
    }

    if (form.dataset.pfUploadLines) {
      lines.push('');
      lines.push(designCheck?.checked && !customerArtCheck?.checked ? '--- Reference images ---' : '--- Artwork files ---');
      lines.push(form.dataset.pfUploadLines);
    }

    return lines.join('\n');
  }

  if (!isPremium) {
    typeRadios.forEach((radio) => {
      if (radio.type !== 'radio') return;
      radio.addEventListener('change', () => {
        updateDesignFeeDisplay();
        updateEstimate();
      });
    });
  }
  qtyInput?.addEventListener('input', updateEstimate);
  function syncCardUploadMode() {
    const upload = form.querySelector('[data-pf-upload]');
    if (!upload || !window.PfArtworkUpload) return;
    var cardMode = 'offer';
    if (customerArtCheck?.checked) cardMode = 'supply';
    else if (designCheck?.checked) cardMode = 'design';
    PfArtworkUpload.setMode(upload, cardMode);
  }
  designCheck?.addEventListener('change', () => {
    updateEstimate();
    syncCardUploadMode();
  });
  customerArtCheck?.addEventListener('change', syncCardUploadMode);
  syncCardUploadMode();
  updateDesignFeeDisplay();
  updateEstimate();

  function cardFieldsHaveValues() {
    return ['contact_name', 'email', 'quantity', 'notes', 'card_full_name'].some((name) => fieldValue(name));
  }

  form.addEventListener('submit', async (e) => {
    if (form.dataset.pfReady === '1') {
      if (bodyField && !bodyField.value.trim() && cardFieldsHaveValues()) {
        bodyField.value = buildBody();
      }
      return;
    }
    e.preventDefault();
    if (!form.querySelector('[data-bc-field="contact_name"]')?.value.trim()) {
      alert('Please enter your contact name.');
      return;
    }
    if (!form.querySelector('[data-bc-field="email"]')?.value.trim()) {
      alert('Please enter your email address.');
      return;
    }
    if (!qtyInput?.value || getQuantity() < minQty) {
      alert(`Please enter at least ${minQty} cards per order.`);
      return;
    }
    if (bodyField) bodyField.value = buildBody();
    if (!window.PfArtworkUpload) {
      alert('File upload did not load. Refresh the page and try again.');
      return;
    }
    const uploaded = await PfArtworkUpload.prepare(form);
    if (!uploaded.ok) return;
    if (uploaded.urls.length) {
      form.dataset.pfUploadLines = uploaded.urls.map((url, index) => `${uploaded.names[index]}: ${url}`).join('\n');
      const urlField = form.querySelector('[data-bc-image-urls]');
      if (urlField) urlField.value = uploaded.urls.join('\n');
    }
    if (bodyField) bodyField.value = buildBody();
    form.dataset.pfReady = '1';
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });
}

function initDesignBuilder() {
  const root = document.querySelector('[data-design-builder]');
  if (!root) return;

  const manifestEl = document.getElementById('DesignBuilderManifestUrl')
    || document.getElementById('ReviewedDesignsManifestUrl');
  const manifestUrl = manifestEl ? JSON.parse(manifestEl.textContent) : null;
  if (!manifestUrl) return;

  const discountPercent = parseFloat(root.dataset.discountPercent || '0');
  const promoDesignFee = parseFloat(root.dataset.designFee || '0');
  const promoLabel = root.dataset.promoLabel || '';
  const quotePrefillLabel = root.dataset.quotePrefillLabel || 'Create Your Own Sublimation request:';
  const hideUpload = root.dataset.hideUpload === 'true';

  const grid = root.querySelector('[data-design-grid]');
  const emptyState = root.querySelector('[data-design-empty]');
  const countEl = root.querySelector('[data-design-count]');
  const searchInput = root.querySelector('[data-design-search]');
  const filterButtons = root.querySelectorAll('[data-folder-filter]');
  const panels = root.querySelectorAll('[data-builder-panel]');
  const stepIndicators = root.querySelectorAll('[data-step-indicator]');
  const selectedImg = root.querySelector('[data-selected-design-img]');
  const selectedTitle = root.querySelector('[data-selected-design-title]');
  const selectedFile = root.querySelector('[data-selected-design-file]');
  const changeDesignBtn = root.querySelector('[data-change-design]');
  const uploadInput = root.querySelector('[data-design-upload]');
  const uploadLabel = root.querySelector('[data-design-upload-label]');
  const blankCards = root.querySelectorAll('[data-blank-type]');
  const blankPicker = root.querySelector('[data-blank-picker]');
  const blankSelection = root.querySelector('[data-blank-selection]');
  const selectedBlankPreview = root.querySelector('[data-selected-blank-preview]');
  const selectedBlankImg = root.querySelector('[data-selected-blank-img]');
  const selectedBlankPlaceholder = root.querySelector('[data-selected-blank-placeholder]');
  const selectedBlankLetter = root.querySelector('[data-selected-blank-letter]');
  const selectedBlankTitle = root.querySelector('[data-selected-blank-title]');
  const selectedBlankDesc = root.querySelector('[data-selected-blank-desc]');
  const selectedBlankPrice = root.querySelector('[data-selected-blank-price]');
  const changeBlankBtn = root.querySelector('[data-change-blank]');
  const addonsPanel = root.querySelector('[data-blank-addons]');
  const addonCards = root.querySelectorAll('[data-addon-for]');
  const addonInputs = root.querySelectorAll('[data-blank-addon]');
  const optionsPanel = root.querySelector('[data-blank-options]');
  const optionGroups = root.querySelectorAll('[data-option-for]');
  const optionInputs = root.querySelectorAll('[data-blank-option]');
  const quoteLink = root.querySelector('[data-design-quote-link]');
  const quoteHint = root.querySelector('[data-design-quote-hint]');
  const actionsEl = root.querySelector('[data-design-builder-actions]');
  const addToCartBtn = root.querySelector('[data-design-add-to-cart]');
  const cartStatus = root.querySelector('[data-design-cart-status]');

  let catalog = null;
  let cartVariants = null;
  let activeFolder = 'all';
  let searchQuery = '';
  let selectedDesign = null;
  let selectedBlank = null;
  let cartBusy = false;

  function assetUrl(relativePath) {
    const base = manifestUrl.replace(/[^/?#]+\.json(?:\?.*)?$/, '');
    return `${base}${relativePath}`;
  }

  function parseMoneyAmount(priceText) {
    if (!priceText || /custom/i.test(priceText)) return null;
    const match = String(priceText).replace(/,/g, '').match(/\$?\s*(\d+(?:\.\d{2})?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function formatDiscountedPrice(priceText) {
    if (!discountPercent || !priceText) return priceText;
    const amount = parseMoneyAmount(priceText);
    if (amount === null) return priceText;
    const discounted = amount * (100 - discountPercent) / 100;
    const formatted = discounted % 1 === 0 ? `$${discounted.toFixed(0)}` : `$${discounted.toFixed(2)}`;
    return `From ${formatted} (${discountPercent}% off)`;
  }

  const excludeFromAllFolders = new Set(
    Array.from(filterButtons)
      .map((btn) => (btn.dataset.excludeFromAll === 'true' ? btn.dataset.folderFilter : null))
      .filter(Boolean),
  );

  function getDesignImageUrl(design) {
    if (!design) return '';
    if (design.isCustomerUpload) return design.image || '';
    return assetUrl(design.image);
  }

  function isCustomerUpload(design) {
    return Boolean(design?.isCustomerUpload || design?.source_folder === 'customer-upload');
  }

  function setStep(step) {
    panels.forEach((panel) => {
      const panelStep = panel.dataset.builderPanel;
      const active = panelStep === String(step);
      panel.hidden = !active;
      panel.classList.toggle('design-builder__panel--active', active);
    });
    stepIndicators.forEach((indicator) => {
      indicator.classList.toggle('design-builder__step--active', indicator.dataset.stepIndicator === String(step));
    });
    if (step === 2) window.scrollTo({ top: root.offsetTop - 24, behavior: 'smooth' });
  }

  function filteredDesigns() {
    if (!catalog) return [];
    return catalog.designs.filter((design) => {
      const folderMatch = activeFolder === 'all'
        ? !excludeFromAllFolders.has(design.folder)
        : design.folder === activeFolder;
      const query = searchQuery.trim().toLowerCase();
      const searchMatch = !query
        || design.title.toLowerCase().includes(query)
        || design.id.toLowerCase().includes(query)
        || (design.filename || '').toLowerCase().includes(query);
      return folderMatch && searchMatch;
    });
  }

  function renderDesigns() {
    const designs = filteredDesigns();
    if (!grid) return;

    grid.innerHTML = '';
    if (countEl) {
      countEl.hidden = false;
      countEl.textContent = `${designs.length} design${designs.length === 1 ? '' : 's'}`;
    }

    if (!designs.length) {
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;

    designs.forEach((design) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'design-builder__card';
      btn.dataset.designId = design.id;
      btn.setAttribute('role', 'listitem');
      if (selectedDesign?.id === design.id && !isCustomerUpload(selectedDesign)) {
        btn.classList.add('design-builder__card--selected');
      }

      btn.innerHTML = `
        <div class="design-builder__card-media">
          <img
            class="design-builder__card-image"
            src="${assetUrl(design.image)}"
            alt="${design.title.replace(/"/g, '&quot;')}"
            loading="lazy"
            width="280"
            height="280"
          >
        </div>
        <p class="design-builder__card-title">${design.title}</p>
      `;

      btn.addEventListener('click', () => selectDesign(design));
      grid.appendChild(btn);
    });
  }

  function selectDesign(design) {
    selectedDesign = design;
    selectedBlank = null;
    if (uploadLabel) uploadLabel.classList.remove('design-builder__upload-card--active');
    renderDesigns();
    updateBlankRecommendations();
    showBlankPickerView();
    updateQuoteLink();
    showSelectedDesign(design);
    setStep(2);
  }

  function showSelectedDesign(design) {
    if (selectedImg) {
      selectedImg.src = getDesignImageUrl(design);
      selectedImg.alt = design.title;
    }
    if (selectedTitle) selectedTitle.textContent = design.title;
    if (selectedFile) {
      const fileLabel = design.filename || `${design.id}.jpg`;
      if (isCustomerUpload(design)) {
        selectedFile.textContent = `File: ${fileLabel} (attach full-resolution file on quote form)`;
      } else {
        selectedFile.textContent = `File: ${fileLabel}`;
      }
      selectedFile.hidden = false;
    }
  }

  function selectCustomerUpload(file, previewUrl) {
    const baseName = file.name.replace(/\.[^.]+$/, '') || 'My image';
    const design = {
      id: 'customer-upload',
      title: baseName,
      image: previewUrl,
      filename: file.name,
      source_folder: 'customer-upload',
      isCustomerUpload: true,
      recommended_blanks: [],
    };
    if (uploadLabel) uploadLabel.classList.add('design-builder__upload-card--active');
    selectDesign(design);
  }

  function updateBlankRecommendations() {
    const recommended = new Set(selectedDesign?.recommended_blanks || []);
    blankCards.forEach((card) => {
      const blankId = card.dataset.blankType;
      card.classList.toggle('design-builder__blank-card--recommended', recommended.has(blankId));
      card.classList.remove('design-builder__blank-card--selected');
    });
  }

  function getSelectedAddons() {
    if (!selectedBlank) return [];
    return Array.from(addonInputs)
      .filter((input) => input.checked)
      .map((input) => {
        const card = input.closest('[data-addon-for]');
        if (!card || card.dataset.addonFor !== selectedBlank.id) return null;
        return {
          title: card.dataset.addonTitle || '',
          price: card.dataset.addonPrice || '',
        };
      })
      .filter(Boolean);
  }

  function formatAddonsLabel(addons) {
    if (!addons.length) return '';
    return addons.map((addon) => `${addon.title} (add to order for ${addon.price})`).join('; ');
  }

  function updateAddonsPanel() {
    if (!addonsPanel) return;
    if (!selectedBlank) {
      addonsPanel.hidden = true;
      return;
    }
    let visibleCount = 0;
    addonCards.forEach((card) => {
      const matches = card.dataset.addonFor === selectedBlank.id;
      card.hidden = !matches;
      if (!matches) {
        const input = card.querySelector('[data-blank-addon]');
        if (input) input.checked = false;
      } else {
        visibleCount += 1;
      }
    });
    addonsPanel.hidden = visibleCount === 0;
  }

  function shouldShowOptionText(group) {
    const wrapper = group.querySelector('[data-blank-option-text-wrap]');
    if (!wrapper) return false;
    const showWhen = wrapper.dataset.blankOptionTextShowWhen;
    if (!showWhen) return true;
    const selected = group.querySelector('[data-blank-option]:checked');
    return Boolean(selected && selected.value === showWhen);
  }

  function updateOptionTextFields() {
    optionGroups.forEach((group) => {
      const wrapper = group.querySelector('[data-blank-option-text-wrap]');
      if (!wrapper) return;
      const show = shouldShowOptionText(group);
      wrapper.hidden = !show;
      const input = wrapper.querySelector('[data-blank-option-text]');
      if (input && !show) input.value = '';
    });
  }

  function getSelectedOptions() {
    if (!selectedBlank) return [];
    return Array.from(optionGroups)
      .filter((group) => group.dataset.optionFor === selectedBlank.id && !group.hidden)
      .map((group) => {
        const selected = group.querySelector('[data-blank-option]:checked');
        if (!selected) return null;
        const heading = group.dataset.optionHeading || 'Options';
        const label = selected.dataset.optionLabel || selected.value;
        const desc = selected.dataset.optionDesc || '';
        const textWrap = group.querySelector('[data-blank-option-text-wrap]');
        const textInput = group.querySelector('[data-blank-option-text]');
        const textLabel = textWrap?.querySelector('.design-builder__option-text-heading')?.textContent?.trim() || '';
        const textValue = shouldShowOptionText(group) ? (textInput?.value?.trim() || '') : '';
        return { heading, label, desc, textLabel, textValue };
      })
      .filter(Boolean);
  }

  function formatOptionsLabel(options) {
    if (!options.length) return '';
    return options.map((opt) => {
      let base = `${opt.heading}: ${opt.label}`;
      if (opt.desc) base = `${base} — ${opt.desc}`;
      if (opt.textValue) {
        const textPart = opt.textLabel ? `${opt.textLabel}: ${opt.textValue}` : opt.textValue;
        base = `${base} (${textPart})`;
      }
      return base;
    }).join('; ');
  }

  function updateOptionsPanel() {
    if (!optionsPanel) return;
    if (!selectedBlank) {
      optionsPanel.hidden = true;
      return;
    }
    let visibleCount = 0;
    optionGroups.forEach((group) => {
      const matches = group.dataset.optionFor === selectedBlank.id;
      group.hidden = !matches;
      if (matches) {
        visibleCount += 1;
        const hasSelection = group.querySelector('[data-blank-option]:checked');
        if (!hasSelection) {
          const defaultInput = group.querySelector('[data-blank-option]');
          if (defaultInput) defaultInput.checked = true;
        }
      }
    });
    optionsPanel.hidden = visibleCount === 0;
    updateOptionTextFields();
  }

  function showBlankPickerView() {
    if (blankPicker) blankPicker.hidden = false;
    if (blankSelection) blankSelection.hidden = true;
    if (addonsPanel) addonsPanel.hidden = true;
    if (optionsPanel) optionsPanel.hidden = true;
    addonInputs.forEach((input) => { input.checked = false; });
  }

  const BLANK_PREVIEW_SIZES = ['compact', 'portrait', 'tall', 'landscape', 'wide', 'square'];

  function inferBlankPreviewSize(img) {
    if (!img?.naturalWidth || !img?.naturalHeight) return null;
    const ratio = img.naturalWidth / img.naturalHeight;
    if (ratio > 2.2) return 'wide';
    if (ratio > 1.2) return 'landscape';
    if (ratio > 0.92 && ratio < 1.08) return 'square';
    if (ratio < 0.62) return 'tall';
    if (ratio < 0.88) return 'portrait';
    return 'landscape';
  }

  function applyBlankPreviewSize(card, img) {
    if (!selectedBlankPreview) return;
    BLANK_PREVIEW_SIZES.forEach((size) => {
      selectedBlankPreview.classList.remove(`design-builder__selection-preview--size-${size}`);
    });
    const configured = card?.dataset?.blankPreviewSize;
    const inferred = img ? inferBlankPreviewSize(img) : null;
    const size = BLANK_PREVIEW_SIZES.includes(configured)
      ? configured
      : (inferred || 'landscape');
    selectedBlankPreview.classList.add(`design-builder__selection-preview--size-${size}`);
  }

  function showSelectedBlank(card) {
    const imageUrl = card.dataset.blankImage || '';
    const title = card.dataset.blankTitle || '';
    const desc = card.dataset.blankDesc || '';
    const price = card.dataset.blankPrice || '';

    applyBlankPreviewSize(card);

    if (selectedBlankImg) {
      if (imageUrl) {
        selectedBlankImg.onload = () => {
          applyBlankPreviewSize(card, selectedBlankImg);
        };
        selectedBlankImg.src = imageUrl;
        selectedBlankImg.alt = title;
        selectedBlankImg.hidden = false;
        if (selectedBlankImg.complete) {
          applyBlankPreviewSize(card, selectedBlankImg);
        }
      } else {
        selectedBlankImg.onload = null;
        selectedBlankImg.hidden = true;
        selectedBlankImg.removeAttribute('src');
      }
    }
    if (selectedBlankPlaceholder) {
      const showPlaceholder = !imageUrl;
      selectedBlankPlaceholder.hidden = !showPlaceholder;
      if (showPlaceholder && selectedBlankLetter) {
        selectedBlankLetter.textContent = title.charAt(0) || '?';
      }
    }
    if (selectedBlankTitle) selectedBlankTitle.textContent = title;
    if (selectedBlankDesc) {
      selectedBlankDesc.textContent = desc;
      selectedBlankDesc.hidden = !desc;
    }
    if (selectedBlankPrice) {
      selectedBlankPrice.textContent = price ? formatDiscountedPrice(price) : '';
      selectedBlankPrice.hidden = !price;
    }
  }

  blankCards.forEach((card) => {
    const priceEl = card.querySelector('.design-builder__blank-price');
    const rawPrice = card.dataset.blankPrice || '';
    if (priceEl && rawPrice) {
      priceEl.textContent = formatDiscountedPrice(rawPrice);
    }
  });

  function showBlankSelectionView(card) {
    if (blankPicker) blankPicker.hidden = true;
    if (blankSelection) blankSelection.hidden = false;
    showSelectedBlank(card);
    window.requestAnimationFrame(() => {
      blankSelection?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  function clearBlankSelection() {
    selectedBlank = null;
    blankCards.forEach((c) => c.classList.remove('design-builder__blank-card--selected'));
    showBlankPickerView();
    updateAddonsPanel();
    updateOptionsPanel();
    updateQuoteLink();
    window.requestAnimationFrame(() => {
      blankPicker?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  function selectBlank(card) {
    if (card.dataset.comingSoon === 'true') return;
    selectedBlank = {
      id: card.dataset.blankType,
      title: card.dataset.blankTitle,
      price: card.dataset.blankPrice,
      quoteService: card.dataset.quoteService,
    };
    blankCards.forEach((c) => c.classList.toggle('design-builder__blank-card--selected', c === card));
    showBlankSelectionView(card);
    updateAddonsPanel();
    updateOptionsPanel();
    updateQuoteLink();
  }

  function resolveCartVariantKey() {
    if (!selectedBlank) return null;
    const blankId = selectedBlank.id;
    const addons = getSelectedAddons();

    if (blankId === 'metal-card') {
      const group = Array.from(optionGroups).find((g) => g.dataset.optionFor === 'metal-card' && !g.hidden);
      const selected = group?.querySelector('[data-blank-option]:checked');
      const raw = `${selected?.value || ''} ${selected?.dataset?.optionLabel || ''}`.toLowerCase();
      if (raw.includes('two-sided') || raw.includes('two sided')) return 'metal-card-two-sided';
      return 'metal-card';
    }

    if (blankId === 'tumbler') {
      const hasStraw = addons.some((addon) => /straw/i.test(addon.title));
      if (hasStraw) return 'tumbler-straw';
    }

    return blankId;
  }

  function getCartVariantEntry() {
    if (!cartVariants?.blanks) return null;
    const key = resolveCartVariantKey();
    if (!key) return null;
    return cartVariants.blanks[key] || null;
  }

  function setCartStatus(message, type) {
    if (!cartStatus) return;
    if (!message) {
      cartStatus.hidden = true;
      cartStatus.textContent = '';
      cartStatus.classList.remove('design-builder__cart-status--error', 'design-builder__cart-status--success');
      return;
    }
    cartStatus.hidden = false;
    cartStatus.textContent = message;
    cartStatus.classList.toggle('design-builder__cart-status--error', type === 'error');
    cartStatus.classList.toggle('design-builder__cart-status--success', type === 'success');
  }

  function absoluteImageUrl(url) {
    if (!url) return '';
    if (/^https?:\/\//i.test(url) || url.startsWith('//') || url.startsWith('data:')) return url;
    try {
      return new URL(url, window.location.origin).href;
    } catch {
      return url;
    }
  }

  function buildCartProperties() {
    const addonsLabel = formatAddonsLabel(getSelectedAddons());
    const optionsLabel = formatOptionsLabel(getSelectedOptions());
    // Library designs: store CDN URL for cart thumbnail. Skip data: URLs (too large for cart props).
    let imageUrl = '';
    if (isCustomerUpload(selectedDesign)) {
      imageUrl = selectedDesign.hostedUrl || '';
    } else {
      imageUrl = absoluteImageUrl(getDesignImageUrl(selectedDesign));
    }
    const props = {
      Design: selectedDesign.title,
      'Design file': selectedDesign.filename || `${selectedDesign.id}.jpg`,
      Blank: selectedBlank.title,
      'Blank ID': selectedBlank.id,
    };
    if (optionsLabel) props.Options = optionsLabel;
    if (addonsLabel) props['Add-ons'] = addonsLabel;
    if (imageUrl) {
      // Public prop for order notes; private prop for theme thumbnail lookup
      props['Design image'] = imageUrl;
      props._design_image = imageUrl;
    } else if (isCustomerUpload(selectedDesign)) {
      props['Customer upload'] = selectedDesign.filename || 'Customer image';
    }
    if (selectedDesign.source_folder && !isCustomerUpload(selectedDesign)) {
      props['Source folder'] = selectedDesign.source_folder;
    }
    if (discountPercent > 0) props.Promo = `${discountPercent}% off (${promoLabel || 'design builder promo'})`;
    return props;
  }

  function updateQuoteLink() {
    const ready = Boolean(selectedDesign && selectedBlank);
    if (actionsEl) actionsEl.hidden = !ready;
    if (quoteLink) quoteLink.hidden = !ready;
    if (quoteHint) quoteHint.hidden = !ready;
    if (addToCartBtn) {
      const variant = ready ? getCartVariantEntry() : null;
      addToCartBtn.hidden = !ready;
      addToCartBtn.disabled = cartBusy || !variant;
      if (ready && !variant) {
        addToCartBtn.title = 'This blank is not available for direct purchase yet';
      } else {
        addToCartBtn.removeAttribute('title');
      }
    }
    if (!ready) {
      setCartStatus('');
      return;
    }
    if (!quoteLink) return;

    quoteLink.dataset.quoteItem = selectedBlank.quoteService;
    quoteLink.dataset.productTitle = `${selectedDesign.title} on ${selectedBlank.title}`;
    quoteLink.dataset.designId = selectedDesign.id;
    quoteLink.dataset.designTitle = selectedDesign.title;
    quoteLink.dataset.designFile = selectedDesign.filename || `${selectedDesign.id}.jpg`;
    quoteLink.dataset.designImageUrl = isCustomerUpload(selectedDesign)
      ? (selectedDesign.hostedUrl || '')
      : getDesignImageUrl(selectedDesign);
    quoteLink.dataset.sourceFolder = selectedDesign.source_folder || '';
    const addonsLabel = formatAddonsLabel(getSelectedAddons());
    const optionsLabel = formatOptionsLabel(getSelectedOptions());
    quoteLink.dataset.blankType = selectedBlank.title;
    quoteLink.dataset.blankId = selectedBlank.id;
    quoteLink.dataset.blankAddons = addonsLabel;
    quoteLink.dataset.blankOptions = optionsLabel;

    if (selectedBlank.id === 'metal-card-premium') {
      const defaultHref = quoteLink.dataset.defaultHref || quoteLink.getAttribute('href');
      if (!quoteLink.dataset.defaultHref) quoteLink.dataset.defaultHref = defaultHref;
      const base = defaultHref.split('#')[0];
      quoteLink.href = `${base}#premium-business-cards`;
      quoteLink.dataset.quoteItem = selectedBlank.quoteService;
    } else if (quoteLink.dataset.defaultHref) {
      quoteLink.href = quoteLink.dataset.defaultHref;
    }
  }

  async function addConfiguredDesignToCart() {
    if (cartBusy || !selectedDesign || !selectedBlank) return;
    const entry = getCartVariantEntry();
    if (!entry?.variantId) {
      setCartStatus('This blank is not available for direct purchase yet. Please request a customization quote instead.', 'error');
      return;
    }

    const defaultLabel = addToCartBtn?.textContent?.trim() || 'Add to cart';
    cartBusy = true;
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding…';
    }
    setCartStatus('');

    try {
      const quantity = Math.max(1, parseInt(entry.minQty, 10) || 1);
      const res = await fetch(window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: Number(entry.variantId),
            quantity,
            properties: buildCartProperties(),
          }],
        }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const message = data?.description || data?.message || 'Could not add this design to cart. Please try again or request a quote.';
        throw new Error(message);
      }

      setCartStatus('Added to cart — opening cart…', 'success');
      window.location.href = window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart`
        : '/cart';
    } catch (err) {
      console.error(err);
      setCartStatus(err.message || 'Could not add this design to cart. Please try again or request a quote.', 'error');
      cartBusy = false;
      if (addToCartBtn) {
        addToCartBtn.disabled = !getCartVariantEntry();
        addToCartBtn.textContent = defaultLabel;
      }
    }
  }

  function storeDesignSelection(design, blank) {
    sessionStorage.setItem('pfDesignId', design.id);
    sessionStorage.setItem('pfDesignTitle', design.title);
    sessionStorage.setItem('pfDesignFile', design.filename || `${design.id}.jpg`);
    sessionStorage.setItem('pfDesignImageUrl', isCustomerUpload(design) ? '' : getDesignImageUrl(design));
    sessionStorage.setItem('pfSourceFolder', design.source_folder || '');
    sessionStorage.setItem('pfCustomerUpload', isCustomerUpload(design) ? 'true' : '');
    const addonsLabel = formatAddonsLabel(getSelectedAddons());
    const optionsLabel = formatOptionsLabel(getSelectedOptions());
    sessionStorage.setItem('pfBlankType', blank.title);
    sessionStorage.setItem('pfBlankAddons', addonsLabel);
    sessionStorage.setItem('pfBlankOptions', optionsLabel);
    sessionStorage.setItem('pfQuoteItem', blank.quoteService);
    sessionStorage.setItem('pfSublimationQuote', '1');
    sessionStorage.setItem('pfProductTitle', `${design.title} on ${blank.title}`);
    sessionStorage.setItem('pfQuotePrefillLabel', quotePrefillLabel);
    if (discountPercent > 0) {
      sessionStorage.setItem('pfPromoDiscount', String(discountPercent));
    } else {
      sessionStorage.removeItem('pfPromoDiscount');
    }
    if (promoLabel) {
      sessionStorage.setItem('pfPromoLabel', promoLabel);
    } else {
      sessionStorage.removeItem('pfPromoLabel');
    }
    if (promoDesignFee > 0) {
      sessionStorage.setItem('pfDesignFee', String(promoDesignFee));
    } else {
      sessionStorage.removeItem('pfDesignFee');
    }
  }

  filterButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      activeFolder = btn.dataset.folderFilter;
      filterButtons.forEach((b) => {
        const active = b === btn;
        b.classList.toggle('design-builder__filter--active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      renderDesigns();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      searchQuery = searchInput.value;
      renderDesigns();
    });
  }

  if (changeDesignBtn) {
    changeDesignBtn.addEventListener('click', () => {
      setStep(1);
      if (uploadLabel && isCustomerUpload(selectedDesign)) {
        uploadLabel.classList.add('design-builder__upload-card--active');
      }
    });
  }

  if (changeBlankBtn) {
    changeBlankBtn.addEventListener('click', () => clearBlankSelection());
  }

  if (uploadInput) {
    uploadInput.addEventListener('change', async () => {
      const file = uploadInput.files?.[0];
      uploadInput.value = '';
      if (!file || !window.PfArtworkUpload) return;
      const ext = (file.name.split('.').pop() || '').toLowerCase();
      if (!['png', 'jpg', 'jpeg', 'tif', 'tiff', 'pdf'].includes(ext)) {
        alert('Use a PNG, JPG, JPEG, TIFF, or PDF file.');
        return;
      }
      if (file.size > 15 * 1024 * 1024) {
        alert('Each file must be 15MB or smaller.');
        return;
      }
      try {
        const url = await PfArtworkUpload.uploadOne(file);
        const preview = file.type.indexOf('image/') === 0 && ext !== 'tif' && ext !== 'tiff'
          ? URL.createObjectURL(file)
          : '';
        selectCustomerUpload(file, preview || url);
        if (selectedDesign) selectedDesign.hostedUrl = url;
        sessionStorage.setItem('pfDesignImageUrl', url);
        sessionStorage.setItem('pfCustomerUpload', 'true');
        sessionStorage.setItem('pfDesignFile', file.name);
        updateQuoteLink();
      } catch (err) {
        alert(err.message || 'The file could not be uploaded.');
      }
    });
  }

  blankCards.forEach((card) => {
    if (card.querySelector('.design-builder__blank-badge')) {
      card.dataset.comingSoon = 'true';
      card.setAttribute('aria-disabled', 'true');
    }
    card.addEventListener('click', () => selectBlank(card));
  });

  addonInputs.forEach((input) => {
    input.addEventListener('change', () => updateQuoteLink());
  });

  optionInputs.forEach((input) => {
    input.addEventListener('change', () => {
      updateOptionTextFields();
      updateQuoteLink();
    });
  });

  root.querySelectorAll('[data-blank-option-text]').forEach((input) => {
    input.addEventListener('input', () => updateQuoteLink());
  });

  if (quoteLink) {
    quoteLink.addEventListener('click', () => {
      if (!selectedDesign || !selectedBlank) return;
      storeDesignSelection(selectedDesign, selectedBlank);
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
      addConfiguredDesignToCart();
    });
  }

  const cartVariantsEl = document.getElementById('DesignBuilderCartVariantsUrl');
  const cartVariantsUrl = cartVariantsEl ? JSON.parse(cartVariantsEl.textContent) : null;
  if (cartVariantsUrl) {
    fetch(cartVariantsUrl)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load cart variants (${res.status})`);
        return res.json();
      })
      .then((data) => {
        cartVariants = data;
        updateQuoteLink();
      })
      .catch((err) => {
        console.error(err);
        cartVariants = { blanks: {} };
      });
  }

  fetch(manifestUrl)
    .then((res) => {
      if (!res.ok) throw new Error(`Failed to load designs (${res.status})`);
      return res.json();
    })
    .then((data) => {
      catalog = data;
      renderDesigns();
    })
    .catch((err) => {
      console.error(err);
      if (emptyState) {
        emptyState.hidden = false;
        emptyState.textContent = 'Unable to load design library. Please refresh and try again.';
      }
    });
}

function initOrderFormLinks() {
  function scrollToTarget(targetId) {
    const el = document.getElementById(targetId);
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function selectQuoteService(serviceId) {
    const checkbox = document.getElementById(`QuoteService-${serviceId}`);
    if (!checkbox) return false;
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function selectQuoteServiceByName(serviceName) {
    if (!serviceName) return false;
    const checkbox = Array.from(document.querySelectorAll('[data-quote-service]'))
      .find((cb) => cb.value === serviceName);
    if (!checkbox) return false;
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function selectBusinessCardPreset(preset) {
    if (!preset) return false;
    if (preset === 'premium_two_sided') return true;
    const radio = document.querySelector(
      `#BusinessCardOrderForm [data-bc-type][value="${preset}"]`
    );
    if (!radio) return false;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function applyDesignFieldsToQuoteForm() {
    const map = [
      ['pfDesignTitle', 'QuoteDesignTitle'],
      ['pfDesignFile', 'QuoteDesignFile'],
      ['pfBlankType', 'QuoteBlankTypeField'],
      ['pfBlankAddons', 'QuoteBlankAddonsField'],
      ['pfBlankOptions', 'QuoteBlankOptionsField'],
      ['pfDesignImageUrl', 'QuoteDesignImageUrl'],
      ['pfSourceFolder', 'QuoteSourceFolder'],
    ];
    map.forEach(([storageKey, fieldId]) => {
      const el = document.getElementById(fieldId);
      const value = sessionStorage.getItem(storageKey);
      if (el) el.value = value || '';
    });
  }

  function prefillQuoteFromProduct(productTitle) {
    if (!productTitle) return;
    const designTitle = sessionStorage.getItem('pfDesignTitle');
    const blankType = sessionStorage.getItem('pfBlankType');
    const blankAddons = sessionStorage.getItem('pfBlankAddons');
    const blankOptions = sessionStorage.getItem('pfBlankOptions');
    const designFile = sessionStorage.getItem('pfDesignFile');
    const designImageUrl = sessionStorage.getItem('pfDesignImageUrl');
    const sourceFolder = sessionStorage.getItem('pfSourceFolder');
    const projectField = document.getElementById('QuoteProject');
    const descriptionField = document.getElementById('QuoteDescription');

    applyDesignFieldsToQuoteForm();

    if (designTitle && blankType) {
      if (projectField && !projectField.value.trim()) {
        projectField.value = `Sublimation project: ${designTitle} on ${blankType}`;
      }
      if (descriptionField && !descriptionField.value.trim()) {
        const prefillLabel = sessionStorage.getItem('pfQuotePrefillLabel') || 'Create Your Own Sublimation request:';
        const promoNote = sessionStorage.getItem('pfPromoLabel');
        const promoDiscount = sessionStorage.getItem('pfPromoDiscount');
        descriptionField.value = [
          prefillLabel,
          promoNote ? `Promotion: ${promoNote}` : '',
          promoDiscount ? `Discount: ${promoDiscount}% off` : '',
          `Design: ${designTitle}`,
          designFile ? `File name (reviewed folder): ${designFile}` : '',
          sourceFolder ? `Folder: ${sourceFolder}` : '',
          `Blank type: ${blankType}`,
          blankAddons ? `Add-ons: ${blankAddons}` : '',
          blankOptions ? `Blank options: ${blankOptions}` : '',
          designImageUrl ? `Image link: ${designImageUrl}` : '',
          '',
          'Quantity:',
          'Additional notes or changes:',
        ].filter(Boolean).join('\n');
      }
      return;
    }

    if (projectField && !projectField.value.trim()) {
      projectField.value = `Customize existing design: ${productTitle}`;
    }
    if (descriptionField && !descriptionField.value.trim()) {
      descriptionField.value = `I'd like to customize this existing design: ${productTitle}. Changes I'd like:`;
    }
  }

  function parseLinkHref(href) {
    if (!href) return { pathname: window.location.pathname, hash: '' };
    if (href.startsWith('#')) {
      return { pathname: window.location.pathname, hash: href.slice(1) };
    }
    try {
      const url = new URL(href, window.location.origin);
      return {
        pathname: url.pathname,
        hash: url.hash ? url.hash.slice(1) : '',
      };
    } catch {
      return { pathname: window.location.pathname, hash: '' };
    }
  }

  function storeOrderLinkState(link) {
    if (link.dataset.quoteItem) {
      sessionStorage.setItem('pfQuoteItem', link.dataset.quoteItem);
    }
    if (link.dataset.bcPreset) {
      sessionStorage.setItem('pfBcPreset', link.dataset.bcPreset);
    }
    if (link.dataset.productTitle) {
      sessionStorage.setItem('pfProductTitle', link.dataset.productTitle);
    }
    if (link.dataset.quoteServiceId) {
      sessionStorage.setItem('pfQuoteServiceId', link.dataset.quoteServiceId);
    }
  }

  function applyOrderPresets(link, hash) {
    const [targetId, preset] = (hash || '').split('--');

    if (targetId === 'quote-form') {
      if (link?.dataset.quoteItem) {
        selectQuoteServiceByName(link.dataset.quoteItem);
      } else if (link?.dataset.quoteServiceId || preset) {
        selectQuoteService(link?.dataset.quoteServiceId || preset);
      } else {
        const storedItem = sessionStorage.getItem('pfQuoteItem');
        const storedId = sessionStorage.getItem('pfQuoteServiceId');
        if (storedItem) selectQuoteServiceByName(storedItem);
        else if (storedId) selectQuoteService(storedId);
      }
      prefillQuoteFromProduct(link?.dataset.productTitle || sessionStorage.getItem('pfProductTitle'));
      document.dispatchEvent(new CustomEvent('pf:quote-services-prefill'));
    } else if (targetId === 'business-cards') {
      const bcPreset = link?.dataset.bcPreset || preset || sessionStorage.getItem('pfBcPreset');
      selectBusinessCardPreset(bcPreset);
    } else if (targetId === 'premium-business-cards') {
      selectBusinessCardPreset('premium_two_sided');
    }
  }

  function clearStoredOrderState() {
    sessionStorage.removeItem('pfQuoteItem');
    sessionStorage.removeItem('pfBcPreset');
    sessionStorage.removeItem('pfProductTitle');
    sessionStorage.removeItem('pfQuoteServiceId');
    sessionStorage.removeItem('pfDesignId');
    sessionStorage.removeItem('pfDesignTitle');
    sessionStorage.removeItem('pfDesignFile');
    sessionStorage.removeItem('pfDesignImageUrl');
    sessionStorage.removeItem('pfSourceFolder');
    sessionStorage.removeItem('pfBlankType');
    sessionStorage.removeItem('pfBlankAddons');
    sessionStorage.removeItem('pfBlankOptions');
    sessionStorage.removeItem('pfCustomerUpload');
    sessionStorage.removeItem('pfPromoDiscount');
    sessionStorage.removeItem('pfPromoLabel');
    sessionStorage.removeItem('pfDesignFee');
    sessionStorage.removeItem('pfQuotePrefillLabel');
    sessionStorage.removeItem('pfSublimationQuote');
  }

  function handleOrderNavigation(link, hash, { updateHistory = true } = {}) {
    if (!hash) return;
    const targetId = hash.split('--')[0];
    if (!targetId) return;

    window.setTimeout(() => {
      scrollToTarget(targetId);
      applyOrderPresets(link, hash);
      clearStoredOrderState();
    }, 120);

    if (updateHistory) {
      history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${hash}`);
    }
  }

  function handleHashNavigation() {
    const raw = location.hash.slice(1);
    if (!raw) return;
    handleOrderNavigation(null, raw, { updateHistory: false });
  }

  function handleStoredOrderNavigation() {
    const hasStored = ['pfQuoteItem', 'pfBcPreset', 'pfProductTitle', 'pfQuoteServiceId', 'pfDesignTitle', 'pfDesignFile']
      .some((key) => sessionStorage.getItem(key));
    if (!hasStored) return;

    const hash = location.hash.slice(1)
      || (sessionStorage.getItem('pfBcPreset') ? `business-cards--${sessionStorage.getItem('pfBcPreset')}` : 'quote-form');

    handleOrderNavigation(null, hash, { updateHistory: false });
  }

  document.querySelectorAll('[data-order-link]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href') || '';
      const { pathname, hash } = parseLinkHref(href);
      const samePage = pathname === window.location.pathname;

      storeOrderLinkState(link);

      if (samePage && hash) {
        e.preventDefault();
        handleOrderNavigation(link, hash);
      }
    });
  });

  handleHashNavigation();
  handleStoredOrderNavigation();
  window.addEventListener('hashchange', handleHashNavigation);
}